import type { WatchRow } from "../api/types";
import { byText } from "./compare";

/** Which band a row sits in. The list is curated, so it does not reorder
 *  itself by recency the way the market index does — the only thing allowed to
 *  move a row up is the thing the user is waiting for. */
function tier(row: WatchRow): number {
  if (row.fulfilled) return 0;
  if (row.quote !== null) return 1;
  return 2;                      // never offered: nothing to read, so last
}

const MODES = ["buy", "sell", "craft"] as const;

/** Hit first, then priced, then the rest; by name and then by mode inside each
 *  band. Stable between polls: with a 60s refetch behind this page, an order
 *  that moved on anything but a hit would shuffle rows under the reader's
 *  cursor for no reason they could see. */
export function sortWatchRows(rows: WatchRow[]): WatchRow[] {
  return [...rows].sort((a, b) =>
    tier(a) - tier(b)
    || byText(a.item, b.item)
    || MODES.indexOf(a.mode) - MODES.indexOf(b.mode));
}
